"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Bucket {
    constructor({ value, count }) {
        this.value = value;
        this.count = count;
    }
}
Bucket.fromJSON = (bucket) => {
    const { value, count } = Object.assign({}, bucket);
    if (typeof value !== 'string') {
        throw new Error('.Bucket.value must be a string');
    }
    if (typeof count !== 'number') {
        throw new Error('.Bucket.count must be a number');
    }
    return new Bucket({ value, count });
};
exports.default = Bucket;
